export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-310x150-e1e2af905e8e892c33756774174495dc.png";